// extracted by mini-css-extract-plugin
export default {"wrapper":"Bt-z","viewport":"Ct-z","container":"Dt-z","slide":"Et-z"};